import * as constants from '../constants';

export interface CopyMessageRequest {
  type: constants.COPY_MESSAGE_REQUEST;
  id: number;
}

export interface CopyMessageSuccess {
  type: constants.COPY_MESSAGE_SUCCESS;
}

export interface CopyMessageFailure {
  type: constants.COPY_MESSAGE_FAILURE;
  error: string;
}

export const copyMessageRequest = (id: number): CopyMessageRequest => {
  return {
    id,    
    type: constants.COPY_MESSAGE_REQUEST,
  };
};

export const copyMessageSuccess = (): CopyMessageSuccess => {
  return {
    type: constants.COPY_MESSAGE_SUCCESS,
  };
};

export const copyMessageFailure = (error: string): CopyMessageFailure => {
  return {
    error,
    type: constants.COPY_MESSAGE_FAILURE,
  };
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/copyMessage.ts